import React from "react";
import Container from "react-bootstrap/Container";
import { Nav } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { HashLink as Link } from "react-router-hash-link";
import YouTube from "react-youtube";
import LegoL99DData from "../legosRefactored-24/dataDriven/LegoL99DData";
import generalNutritionCards from "../legosRefactored-24/dataDriven/generalNutritionCards";
import foodDiaryCards from "../legosRefactored-24/dataDriven/foodDiaryCards";
import gutHealthCards from "../legosRefactored-24/dataDriven/gutHealthCards";
import kidneyHealthCards from "../legosRefactored-24/dataDriven/kidneyHealthCards";
import boneHealthCards from "../legosRefactored-24/dataDriven/boneHealthCards";
import managingDiabetesCards from "../legosRefactored-24/dataDriven/managingDiabetesCards";
import LegoL99AData from "../legosRefactored-24/dataDriven/LegoL99AData";
import websitesCards from "../legosRefactored-24/dataDriven/websitesCards";

const LivingWellCenter6_2 = () => {
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    <div>
      <div className="w-100 legosNewBuild livingWellCenterHeader">
        <section className="mb-0">
          {/* L6 Background image header bar */}
          <div className="lego l006 legoMargin5">
            <div
              className="backgroundImage"
              style={{
                backgroundImage:
                  "url(" +
                  "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/0d445c7f791eb836ce7a12e72e3003b1.jpeg" +
                  ")",
                backgroundPosition: "80% 0%",
              }}
            >
              <div
                className="transparentBarTypeContainer"
                style={{
                  backgroundColor: "#FA4E36",
                }}
              >
                &nbsp;&nbsp;
              </div>
              <h2 className="l6SubheadWithBackground">
                Weight Loss & Nutrition
              </h2>
            </div>
          </div>
          {/* End L6 Background image header bar */}
        </section>
        <Container>
          <div className="w-100">
            <div className="col-12 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild livingWellCenterHeader">
                <section>
                  {/* L00jumpNav - section jump-link navigation (above the intro header, per Figma) */}
                  <div className="lego l00jumpNav legoMargin4">
                    <nav className="jumpNavContainer">
                      <Link smooth replace className="jumpNavButton" to="#generalNutrition">General Nutrition</Link>
                      <Link smooth replace className="jumpNavButton" to="#gutHealth">Gut Health</Link>
                      <Link smooth replace className="jumpNavButton" to="#kidneyHealth">Kidney Health</Link>
                      <Link smooth replace className="jumpNavButton" to="#boneHealth">Bone Health</Link>
                      <Link smooth replace className="jumpNavButton" to="#managingDiabetes">Managing Diabetes</Link>
                      <Link smooth replace className="jumpNavButton" to="#helpfulWebsitesApps">Helpful Websites &amp; Apps</Link>
                    </nav>
                  </div>
                  {/* End L00jumpNav */}

                  {/* L12A Head, Lead In Photo Larger with body copy */}
                  <div className="lego l012A">
                    <div className="contentContainer">
                      <div
                        className="imgContainer"
                        style={{ minWidth: "500px" }}
                      >
                        <img
                          className=""
                          alt="Adults of Mulitple Ethnicities doing Tai Chi"
                          src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/09f122dce6580fd5676488e38a3cc11b.jpeg"
                        />
                      </div>
                      <div className="copyContainer">
                        {/* L14 Paragraph */}
                        <div className="lego l00paragraph legoMargin3">
                          <p className="legoMargin2">
                            <span className="bold italic">
                              If you need to lose weight in order to improve
                              your health, the Washington University Living Well
                              Center® can help. 
                            </span>
                          </p>
                          <p className="legoMargin2">
                            We offer dietitian-led weight loss shared medical
                            appointments expertly designed to help you drop
                            excess weight using the latest evidence-based
                            approach that focuses on how to expand your healthy
                            food intake and provide education as to what foods
                            to limit and why. The program includes the support
                            and resources you need to meet your goal.
                          </p>
                          <p className="legoMargin2">
                            {" "}
                            By using a whole-food, plant-predominant lifestyle,
                            you will reduce your weight and the risk of chronic
                            diseases (such as diabetes and hypertension)
                            associated with excess weight and obesity.{" "}
                          </p>
                          <p className="legoMargin2">
                            Participants receive guidance from a dietitian who
                            specializes in plant-based diet and healthy
                            lifestyles, as well as social support from peers in
                            a group setting.
                          </p>{" "}
                          <p className="legoMargin2">
                            The education you receive will go beyond just food
                            and will include comprehensive lifestyle medicine –
                            a recipe for long-term success. We give you tools to
                            meet your weight loss goals (our methods are proven
                            to result in greater weight loss) and maintain your
                            success long-term. Four biweekly group sessions are
                            delivered virtually and in-person, increasing safe
                            access to patients everywhere.
                          </p>
                          <p>
                            Click to{" "}
                            <a
                              className="blueLinkfont18"
                              href="https://www.ortho.wustl.edu/content/Patient-Care/8357/Services/Living-Well-Center/Living-Well-Center-Weight-Loss-Program.aspx"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              Learn More
                            </a>
                          </p>
                        </div>
                        {/* End L14 Paragraph */}
                      </div>
                    </div>
                  </div>
                  {/* End L12A Head, Lead In Photo Larger with body copy */}

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== GENERAL NUTRITION ===== */}
                  <div className="lego l004 legoMargin3" id="generalNutrition">
                    <h2 className="subHeadAllCaps coralHeading">GENERAL NUTRITION</h2>
                  </div>
                  <LegoL99DData cards={generalNutritionCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== KEEPING A FOOD AND BEVERAGE DIARY ===== */}
                  <div className="lego l004 legoMargin3" id="foodDiary">
                    <h2 className="subHeadAllCaps coralHeading">KEEPING A FOOD AND BEVERAGE DIARY</h2>
                  </div>
                  <LegoL99DData cards={foodDiaryCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== GUT HEALTH ===== */}
                  <div className="lego l004 legoMargin3" id="gutHealth">
                    <h2 className="subHeadAllCaps coralHeading">GUT HEALTH</h2>
                  </div>
                  <LegoL99DData cards={gutHealthCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== KIDNEY HEALTH ===== */}
                  <div className="lego l004 legoMargin3" id="kidneyHealth">
                    <h2 className="subHeadAllCaps coralHeading">KIDNEY HEALTH</h2>
                  </div>
                  <LegoL99DData cards={kidneyHealthCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== BONE HEALTH ===== */}
                  <div className="lego l004 legoMargin3" id="boneHealth">
                    <h2 className="subHeadAllCaps coralHeading">BONE HEALTH</h2>
                  </div>
                  <LegoL99DData cards={boneHealthCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066"><hr className="horizonalRule" /></div>
                  {/* End L66 Divider Rule */}

                  {/* ===== MANAGING DIABETES ===== */}
                  <div className="lego l004 legoMargin3" id="managingDiabetes">
                    <h2 className="subHeadAllCaps coralHeading">MANAGING DIABETES</h2>
                  </div>
                  <LegoL99DData cards={managingDiabetesCards} />

                  {/* L66 Divider Rule */}
                  <div className="lego l066">
                    <hr className="horizonalRule" />
                  </div>
                  {/* End L66 Divider Rule */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin3">
                    <h2 className="subHeadAllCaps coralHeading" id="helpfulWebsitesApps">HELPFUL WEBSITES AND APPS</h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* Websites to check out */}
                  <div className="lego l00paragraph2 legoMargin4">
                    <p style={{ textAlign: "center" }}>
                      <span className="paragraph22px" style={{ fontStyle: "normal" }}>
                        Websites to check out
                      </span>
                    </p>
                  </div>
                  <LegoL99AData cards={websitesCards} />

                  {/* Helpful Apps */}
                  <div className="lego l00paragraph2 legoMargin4">
                    <p style={{ textAlign: "center" }}>
                      <span className="paragraph22px" style={{ fontStyle: "normal" }}>
                        Helpful Apps
                      </span>
                    </p>
                  </div>

                  <div className="appGrid">
                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.pcrm.org/news/news-releases/21-day-vegan-kickstart-program-launches-new-website-and-phone-app">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/21DayVegan.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">
                          21-Day Vegan Kickstart
                        </p>
                        <p>
                          A free app designed to provide a 3-week plant-based
                          meal plan. Plans are designed for nutritional
                          completeness and are paired with recipe libraries and
                          nutritional guidance.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.pcrm.org/news/news-releases/21-day-vegan-kickstart-program-launches-new-website-and-phone-app"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://getbitesnap.com/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/Bitesnap.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Bitesnap</p>
                        <p>
                          (Available on App Store and Google Play Store, free):
                          This simple app allows users to keep a photo diary of
                          the meals they consume throughout the day and
                          visualize the amount of food they are consuming. The
                          app also includes a calorie-counting feature.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://getbitesnap.com/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://get.gg/docs/CravingsDiary.pdf">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/ClassPass_app_logo.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Cravings Diary</p>
                        <p>
                          This template provides users with the opportunity to
                          pause when experiencing a craving, and to further
                          query the nature of the craving and their experience
                          of it. The questions provided on the document are
                          applicable to cravings both related and unrelated to
                          food.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://get.gg/docs/CravingsDiary.pdf"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://nutritionfacts.org/daily-dozen/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/DrGregersDailyDozen.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">
                          Dr. Greger’s Daily Dozen
                        </p>
                        <p>
                          Free, checklist-style app that inspires you to include
                          the healthiest foods into your daily meals.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://nutritionfacts.org/daily-dozen/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://goeatrightnow.com/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/EatingNow.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Eat Right Now</p>
                        <p>
                          (Available on App Store and Google Play Store): This
                          mobile app provides users with 4 free modules that are
                          tailored to their goals around food. The app prompts
                          users at intervals to assess their own emotional and
                          physical state and, in so doing, promotes the
                          development of mindfulness. A monthly subscription is
                          required after completion of the first 4 modules
                          ($24.99/month).
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://goeatrightnow.com/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://shop.forksoverknives.com/pages/save-50-now">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/ForksMealPlanner.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Forks Meal Planner</p>
                        <p>
                          Accessible via free online trial or through the paid
                          mobile app. Provides plant-based, oil-free recipes for
                          breakfast, lunch, dinner, and a snack. Weekly meal
                          plans include a grocery list, meal prep, and
                          members-only community.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://shop.forksoverknives.com/pages/save-50-now"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.fooducate.com/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/Fooducate.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Fooducate</p>
                        <p>
                          Improve your health by creating good habits & eating
                          more mindfully.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.fooducate.com/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.happycow.net/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/HappyCow.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Happy Cow</p>
                        <p>
                          The go-to app for finding plant-based food near you!
                          This app filters by “Vegan,” “Vegetarian,” and “Vegan
                          Options,” to help you find restaurants, cafes, and
                          grocery stores in 180+ countries. Simply search by
                          dropping a pin on the map or typing in the area you’re
                          visiting—Favorite lists and Travel lists are a great
                          feature for future use. Users can leave reviews with
                          pictures on each business’s page, making it easy to
                          find what you’re looking for.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.happycow.net/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.lighter.world/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/lighter.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Lighter</p>
                        <p>
                          Provides meal plans customizable by personal health
                          goals, appetite, preparation time, and cooking skill.
                          Meals are paired with a grocery list. Free trial
                          available.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.lighter.world/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.myfitnesspal.com/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/MyFitnessPal.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">MyFitnessPal</p>
                        <p>
                          A free calorie-counting app that tracks
                          macronutrients, vitamins, fiber, and other minerals.
                          Users may also log their water consumption and
                          exercise with this app. Users can sync data from
                          MyFitnessPal with the FitBit, Garmin, and Apple Health
                          apps, and more!
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.myfitnesspal.com/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.mynetdiary.com/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/MyNetDiary.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">MyNetDiary</p>
                        <p>
                          A free weight and food tracking app which provides
                          daily and weekly analyses of users’ diets,
                          macronutrients, and micronutrients. A barcode scanner
                          and nutrition tips are provided. A public
                          discussion/support forum is also available for users.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.mynetdiary.com/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://mealplanner.richroll.com">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/PlantPowerMealPlanner.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">
                          The Plantpower Meal Planner
                        </p>
                        <p>
                          Personalized meal planner based on goals, kitchen
                          skills, time to cook, and other preferences. Also
                          includes support from food coaches and cooking
                          technique videos. Click image or this link to view.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank" className="blueLinkfont" href="https://mealplanner.richroll.com">
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.noom.com/?route=_direct&utm_content=453318178305&utm_term=kwd-299095591416%7Cnoom">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/noom.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Noom</p>
                        <p>
                          Psychology-based lifestyle change app for long-term
                          weight loss. This app is subscription-based and
                          creates a customized plan that includes mini-lessons
                          in psychology and behavior change. Food tracking
                          follows a green/yellow/red system, and allows for
                          dietary preferences. Includes a coach-moderated peer
                          support group. Free one-week trial available. Click
                          image or this link to view.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.noom.com/?route=_direct&utm_content=453318178305&utm_term=kwd-299095591416%7Cnoom"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://yuka.io/en/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/Yuka.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">Yuka app</p>
                        <p>
                          Bring this app to the grocery store to evaluate food
                          quality before you check-out! Features a barcode
                          scanner that provides you with an immediate grade:
                          from excellent to bad. This may be particularly
                          helpful for processed foods. Remember: the healthiest
                          foods don’t have barcodes!
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://yuka.io/en/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}

                  {/* L99A App Icon and Description New */}
                  <div className="lego l099A legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" href="https://www.innit.com/shopwell/">
                          <img
                            className=""
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/Shopwell.png"
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">ShopWell</p>
                        <p>
                          Simplifies nutrition labels and helps you discover new
                          foods that fit your lifestyle.
                        </p>
                        <p style={{ fontStyle: "italic" }}>
                          Click image or{" "}
                          <a target="_blank"
                            className="blueLinkfont"
                            href="https://www.innit.com/shopwell/"
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99A App Icon and Description New */}
                  </div>
                  {/* end appGrid */}

                  <div className="col-12 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default LivingWellCenter6_2;
